  // Terms of conditions / legals section
export function openLink(url){
  var win = window.open(url, '_blank');
  win.focus();
}